module.exports = __webpack_public_path__ + "img/objective-c.e8b091fd.png";